import SingletonWebSocket from '../Singletons/SingletonWebSocket'
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { INTEGRATION, INTEGRATION_SUBACTION } from '../../constants';
import { Logger } from '../../js/helpers/Logger';

let APIFact = new APIFactory();
export const STRATEGIES_REDUCER_INTEGRATION = {
    "Logout": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][Logout] Logout");
        that.props.logout();
    },
    "getUnavailables": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][getUnavailables] getUnavailables");
        let objectResponse = that.apiCont.getObjectResponse();
        that.apiCont.getListNoAvailable(that.sharedData.getParameters().UserID, objectResponse,that.sharedData.getRequestTimeout());
        objectResponse.onError = function (messageError) {
            const type = messageError.Type;
            const code = messageError.InternalCode
            const error = that.language.getText(`${type.toLowerCase()}-${code}`);
            Logger.Warning("[Strategies_Reducer_Integration][getUnavailables] Error consulting data base =>", error);
            const integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnUnavailableStatus" };
            SingletonWebSocket.send(integrationMessage);
        };
        objectResponse.onSuccess = function (objResponse) {
            Logger.Trace("[Strategies_Reducer_Integration][getUnavailables] Sending unavailables to integration =>", objResponse.Response);
            let message = { client: "galatea", data: objResponse.Response, action: "getUnavailables" };            SingletonWebSocket.send(message);
        };
    },
    "SupervisorsToChat": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][SupervisorsToChat] SupervisorsToChat");
        var apiCont = APIFact.buildClient();
        let objectResponse = apiCont.getObjectResponse();
        Logger.Trace("[Strategies_Reducer_Integration][SupervisorsToChat] Looking for Supervisor List");
        apiCont.getSupervisorList(message, objectResponse);
        objectResponse.onError = function (messageError) {
            Logger.Warning("[Strategies_Reducer_Integration][SupervisorsToChat] Error Supervisor List =>", messageError);
        };
        objectResponse.onSuccess = function (objResponse) {
            Logger.Trace("[Strategies_Reducer_Integration][SupervisorsToChat] Supervisor List =>", objResponse);
            SingletonWebSocket.send(
                SingletonWebSocket.getJson(INTEGRATION.CHAT, INTEGRATION_SUBACTION.CHAT_SUPERVISORS, objResponse));
        };
    },
    "setUnavailable": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][setUnavailable] setUnavailable");
        var _that = that;
        that.props.sendMessageNoAvailable(_that.sharedData.getUserData().Login,
            _that.sharedData.getParameters().UserID,
            message.unavailableID,0);
    },
    "setReady": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][setReady] setReady");
        that.props.messageChangeState();
    },
    "CallAction": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][CallAction] CallAction");
        if (message.callAction === "UpdateDataCall") {
            let obj = that.state.dataCall;
            obj.DataContact = message.data;
        }
    },
    "transferCallToACD": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][transferCallToACD] transferCallToACD");
        that.props.messageTransferCall(message.data);
    },
    "transferCallToAgent": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][transferCallToAgent] transferCallToAgent");
        that.props.messageTransferCall(message.data);
    },
    "transferCallToPhoneNumber": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][transferCallToPhoneNumber] transferCallToPhoneNumber");
        that.props.messageTransferCall(message.data);
    },
    "getUnavailableHistory": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][getUnavailableHistory] getUnavailableHistory");
        let objectResponse = that.apiCont.getObjectResponse();
        that.apiCont.getNotReadyHistory(that.sharedData.getParameters().UserID, objectResponse);
        objectResponse.onError = function (messageError) {
            const type = messageError.Type;
            const code = messageError.InternalCode
            const error = that.language.getText(`${type.toLowerCase()}-${code}`);
            Logger.Warning("[Strategies_Reducer_Integration][getUnavailableHistory] Error consulting data base =>", error);
            const integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnUnavailableStatusHistory" };
            SingletonWebSocket.send(integrationMessage);
        };
        objectResponse.onSuccess = function (objResponse) {
            Logger.Trace("[Strategies_Reducer_Integration][getUnavailableHistory] Sending History to integration =>", objResponse.Response);
            let message = { client: "galatea", data: objResponse.Response, action: "onUnavailableHistory" };
            SingletonWebSocket.send(message);
        };
    },
    "GetAgentID": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][GetAgentID] GetAgentID");
        let messageAgentID = { client: "galatea", data: that.sharedData.getParameters().UserID, action: "GetAgentID" };
        SingletonWebSocket.send(messageAgentID);
    },
    "GetUserName": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][GetUserName] GetUserName");
        let messageUserName = { client: "galatea", data: that.sharedData.getUserData().Login, action: "GetUserName" };
        SingletonWebSocket.send(messageUserName);
    },
    "GetExtension": (that, message) => {
        Logger.Trace("[Strategies_Reducer_Integration][GetExtension] GetExtension");
        let messageExtension = { client: "galatea", data: that.sharedData.getParameters().Extension, action: "GetExtension" };
        SingletonWebSocket.send(messageExtension);
    },
};



// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Reducer_Integration.js